 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","components-agents-agents-module":"components-agents-agents-module","components-anpaungPage-anpaung-page-module":"components-anpaungPage-anpaung-page-module","components-dashboard-dashboard-module":"components-dashboard-dashboard-module","components-gamepages-game-module":"components-gamepages-game-module","components-homepages-home-module":"components-homepages-home-module","components-levelpages-levelpages-module":"components-levelpages-levelpages-module","components-profilepages-profile-module":"components-profilepages-profile-module","components-promotionpages-promotion-module":"components-promotionpages-promotion-module","components-servicepages-service-module":"components-servicepages-service-module","components-signin-upPages-account-module":"components-signin-upPages-account-module","default~components-dpages-dpage-module~components-walletpages-wallet-module":"default~components-dpages-dpage-module~components-walletpages-wallet-module","components-dpages-dpage-module":"components-dpages-dpage-module","components-walletpages-wallet-module":"components-walletpages-wallet-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-23c95dd7-js":"shadow-css-23c95dd7-js","swiper-bundle-95afeea2-js":"swiper-bundle-95afeea2-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-1eb64a0f-js":"input-shims-1eb64a0f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-dc6b4b49-js":"status-tap-dc6b4b49-js","swipe-back-7f7c9a3b-js":"swipe-back-7f7c9a3b-js","tap-click-2553704d-js":"tap-click-2553704d-js"}[chunkId]||chunkId) + "." + {"0":"4e15cbd9ad739daa2e2f","1":"324efc12db869e1a1aed","2":"1893f142c7625e1c66ec","3":"1085cedf857c71de562f","4":"8b33c93611be3f7ae1cb","5":"8573aa9e35e26df41627","6":"e6cd8d1c874143feb6d3","7":"3c23ae7c4e15f6511e79","8":"0eac010e323cbb4729fd","9":"21519fc78b3819d2bf61","10":"7974f0a38341399e2213","11":"a8b911c0297e05945a69","12":"43509c5deceeefd03932","13":"b523b80cf1bd32f0e996","14":"3a20379441d4e62c2e3c","15":"257b186283a65fcba0a2","16":"00a3fbbb4889741d7c95","17":"e8920f38ea320b2bef25","18":"d904d90822ef1564f47f","19":"b5973c99e8f878d4824d","20":"c549cac0b610be358270","21":"2ba09cad15bdf0422f72","22":"6951ab217aebd9d5b849","23":"ae6c0099f1c121bf6017","24":"9c683fc5bde655975cdf","25":"4b8d7ee78966c3874862","26":"2cf062bdeaf24a21360f","27":"d48689981fd683c70b9e","28":"e0b77636b84a257a2892","29":"96000b9c1c7f2236cf38","30":"c4bdc2fa09f62a766c0a","31":"f1c90354c75914574043","32":"bc455127801e066f450f","33":"9e96065f64856777a8ea","34":"1fd1f9c557cbd9105907","35":"f3a36253cd5d7c2ff3ef","36":"2ba4813c375cce2bf776","37":"d150616f9050a2a91cae","38":"0ce244e3ef754728c741","39":"a82c2e714fd6a27d2c4f","40":"3b076eaf24ba0c65ac69","41":"836e004f5332f50ab1a9","42":"9ea30318511cae93fc9b","common":"32c9d10f87ea00a4d025","components-agents-agents-module":"717b7863a950fb5d068b","components-anpaungPage-anpaung-page-module":"77966d473c6e1baa0cb4","components-dashboard-dashboard-module":"433a40d695abd2fa18e4","components-gamepages-game-module":"0475770b92fbca8a1115","components-homepages-home-module":"78a7da474a3ae42b2478","components-levelpages-levelpages-module":"641a9bdb9cdc9cbbc594","components-profilepages-profile-module":"746960bf6195022fcf48","components-promotionpages-promotion-module":"0ebd46fe585cb02e3aec","components-servicepages-service-module":"94af5d0238bb14ae1a97","components-signin-upPages-account-module":"51c3711addb99d3f1192","default~components-dpages-dpage-module~components-walletpages-wallet-module":"6598f8c83c61117058a9","components-dpages-dpage-module":"1d309a3df263bcbfabc7","components-walletpages-wallet-module":"d3028cc5a8d8b5e8c7c5","polyfills-core-js":"e073442f315be40ebe4e","polyfills-css-shim":"67994a612cc6364ef7a8","polyfills-dom":"05b6ac99d72450f64abd","shadow-css-23c95dd7-js":"3f175ff5d99855c84944","swiper-bundle-95afeea2-js":"06cbcd143370594b47af","focus-visible-f4ad4f1a-js":"dc1a002f3a09677b0a7a","input-shims-1eb64a0f-js":"254bfd332ec71e4bb08d","keyboard-5742b5da-js":"fde02f8813db54602147","status-tap-dc6b4b49-js":"79ae7d2783d8d8d0a09d","swipe-back-7f7c9a3b-js":"e6a00f54e058a5c94c27","tap-click-2553704d-js":"fb53ba09adbecb156524"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
